import React, { Component } from 'react';

export default class ExceededMessage extends Component {

  render() {
    return (
      <React.Fragment>
        BookThatApp free trial exceeded:
        <br/>
        <br/>
        you have exceeded the maximum number of bookings allowed under your free trial.
        Please <span><a href="/admin/charges">upgrade to a paid</a></span> BookThatApp subscription plan to continue using the App.
      </React.Fragment>
    );
  }
}
